import { PropsWithChildren } from 'react';
import Tooltip, { TooltipDirection } from 'lib/Tooltip';

interface ChipWithTooltipProps {
  tooltipContent: string[];
}

const ChipWithTooltip: React.FC<PropsWithChildren<ChipWithTooltipProps>> = ({ tooltipContent, children }) => {
  return (
    <div className="flex justify-end">
      <Tooltip
        direction={TooltipDirection.BOTTOM}
        tooltip={
          <div className="flex flex-col gap-y-1">
            {tooltipContent.map((value) => (
              <span key={`${value}-tooltip-content`}>{value}</span>
            ))}
          </div>
        }
      >
        <div className="flex flex-col gap-1 items-end">{children}</div>
      </Tooltip>
    </div>
  );
};

export default ChipWithTooltip;
